const InactiveStatusIcon = ({
  width = 11,
  height = 11,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 11 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M6.64579 3.20801L4.35413 5.49967' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M1.83337 8.93783V2.06283C1.83337 1.75893 1.9541 1.46748 2.16898 1.2526C2.38387 1.03771 2.67531 0.916992 2.97921 0.916992H8.70837C8.82993 0.916992 8.94651 0.965281 9.03247 1.05123C9.11842 1.13719 9.16671 1.25377 9.16671 1.37533V9.62533C9.16671 9.74688 9.11842 9.86346 9.03247 9.94942C8.94651 10.0354 8.82993 10.0837 8.70837 10.0837H2.97921C2.67531 10.0837 2.38387 9.96294 2.16898 9.74805C1.9541 9.53317 1.83337 9.24172 1.83337 8.93783ZM1.83337 8.93783C1.83337 8.63393 1.9541 8.34248 2.16898 8.1276C2.38387 7.91271 2.67531 7.79199 2.97921 7.79199H9.16671'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M4.35413 3.20801L6.64579 5.49967' stroke={color} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default InactiveStatusIcon;
